import { render, staticRenderFns } from "./OtpByStops.vue?vue&type=template&id=48c52725&scoped=true"
import script from "./OtpByStops.vue?vue&type=script&lang=js"
export * from "./OtpByStops.vue?vue&type=script&lang=js"
import style0 from "./OtpByStops.vue?vue&type=style&index=0&id=48c52725&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c52725",
  null
  
)

export default component.exports